import loadScript from './load-script';

const GoogleRecaptcha = {
    loaded: null,
    load: function() {
        if (GoogleRecaptcha.loaded === null) {
            if (window.grecaptcha) {
                GoogleRecaptcha.loaded = Promise.resolve();
            } else {
                let url = "https://www.google.com/recaptcha/api.js?render=explicit&onload=onGoogleRecaptchaV2Ready";
                let lang = document.documentElement.getAttribute("lang");
                if (lang) {
                    url += "&htl=" + lang;
                }
                const captchaOnLoad = new Promise((resolve) => {
                    window.onGoogleRecaptchaV2Ready = resolve;
                }).then(() => {
                    delete window.onGoogleRecaptchaV2Ready;
                });
                GoogleRecaptcha.loaded = Promise.all([loadScript(url), captchaOnLoad]);
            }

        }
        return GoogleRecaptcha.loaded;
    }
}

export default GoogleRecaptcha;